module.exports = __webpack_public_path__ + "images/homepage-step3.svg";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-step3.svg
// module id = 854
// module chunks = 0